// 我的设置
<template>
  <div class="setting">
    <van-nav-bar
      :title="$t('menu.setting')"
      @click-left="$router.go(-1)"
      left-arrow
      fixed
      placeholder
    >
    </van-nav-bar>
    <div style="margin-top: 30px">
      <van-cell-group inset :border="false">
        <van-cell
          title="Language"
          value="English"
          value-class="content"
          is-link
          :border="false"
        />
        <!-- <van-cell title="User Agreement" is-link :border="false" to="" /> -->
        <!-- <van-cell title="User make terms" is-link :border="false" /> -->
        <van-cell
          title="Change password"
          is-link
          :border="false"
          to="forget"
        />
        <van-cell
          title="Privacy policy"
          is-link
          :border="false"
          @click="toIframeWithBar('https://appweb.arcticdolphin.net/agreement/PrivacyAgreementEn.html')"
        />
        <van-cell
          title="Check for updates"
          is-link
          :border="false"
          @click="check4Updates"
        />
        <van-cell
          title="About App"
          is-link
          :border="false"
          @click="getVersionInfo"
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import TabBar from "@/components/tab-bar";
import { getVersion } from "@/api";
export default {
  name: "Setting",
  components: {
    TabBar,
  },
  data() {
    return {
      userInfo: {},
    };
  },
  computed: {
    currency() {
      return this.$store.getters.currency;
    },
    token() {
      return this.$store.state.user.token;
    },
    menuActive() {
      const activeArr = [];
      this.menu.map((item) => {
        if (item.isToken) {
          if (this.token) {
            activeArr.push(item);
          }
        } else {
          activeArr.push(item);
        }
      });
      return activeArr;
    },
  },
  methods: {
    /** 检查更新按钮 */
    check4Updates() {
      window.webkit.messageHandlers.check4Updates.postMessage("Meaningless");
    },
    getVersionInfo() {
      getVersion({
        versionType: 1,
      }).then((res) => {
        this.$toast(res.data.versionCode);
      });
    },
    // 跳转
    linkTo(row) {
      this.$router.push(row.path);
    },
    /** 跳转到外部连接 */
    toIframeWithBar(url) {
      this.$router.push({
        name: "iframeWithBar",
        params: {
          urlOfIframe: url
        }
      });
    },
  },
  filters: {
    // 电话格式化
    formatPhone(params) {
      let val = params + "";
      const d = val.substring(3, 8);
      val = val.replace(new RegExp(d, "g"), "*****");
      return val;
    },
  },
};
</script>

<style lang="less">
.setting {
  .van-cell-group {
    background: transparent;
    .van-cell {
      background: transparent;
    }
    .content {
      color: #000;
      font-weight: bold;
    }
  }
}
</style>
